// extracted by mini-css-extract-plugin
export default {"main":"FormsFormDetails_main__rGa9r","edit":"FormsFormDetails_edit__qJlPF"};